// это прямоугольная штука, в которой сверху большое число, а снизу - небольшой текст
import React, { Component } from 'react';
import './style.css';

/**
 * 
 * AvatarComponent - что то, что принмает в себя size
 */
export class NumberText extends Component {

    static defaultProps = {
        upperAutoFit: false,   // включать перенос/подгонку верхнего текста
        upperMaxLines: 2,      // максимум строк для верхнего текста при upperAutoFit
        upperMaxFontSize: null,// потолок размера шрифта (px) для верхнего текста
    };

    upperRef = React.createRef();

    state = { upperFont: null };

    componentDidMount() {
        this.fitUpperText();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.count !== this.props.count ||
            prevProps.text !== this.props.text ||
            prevProps.height !== this.props.height ||
            prevProps.upperAutoFit !== this.props.upperAutoFit ||
            prevProps.upperMaxLines !== this.props.upperMaxLines ||
            prevProps.upperMaxFontSize !== this.props.upperMaxFontSize
        ) {
            this.fitUpperText();
        }
    }

    /**
     * Подбирает максимальный размер шрифта верхнего текста так, чтобы он влезал
     * максимум в upperMaxLines строк и по высоте помещался в верхнюю область плашки.
     * Используется для длинных названий регионов («Московская область» и т.п.).
     */
    fitUpperText = () => {
        const { upperAutoFit, upperMaxLines, upperMaxFontSize, height } = this.props;
        const el = this.upperRef.current;

        if (!upperAutoFit) {
            if (this.state.upperFont !== null) this.setState({ upperFont: null });
            return;
        }
        if (!el) return;

        const area = el.parentNode || el;
        const areaH = area.clientHeight || height;
        const maxLines = upperMaxLines || 2;
        const ratio = 1.05;
        const minFont = 5;

        // бинарный поиск: ищем самый крупный шрифт, который ещё укладывается в maxLines строк
        let lo = minFont;
        let hi = upperMaxFontSize ? Math.round(upperMaxFontSize) : Math.max(minFont, Math.round(height / 1.4));
        let best = minFont;

        while (lo <= hi) {
            const mid = Math.floor((lo + hi) / 2);
            const lh = mid * ratio;
            el.style.fontSize = `${mid}px`;
            el.style.lineHeight = `${lh}px`;
            const lines = Math.round(el.scrollHeight / lh);
            const fits = (lines <= maxLines) && (el.scrollHeight <= areaH + 2);
            if (fits) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
        }

        if (this.state.upperFont !== best) this.setState({ upperFont: best });
    }

    render() {
        const { count, text, height, upperAutoFit, upperMaxFontSize } = this.props;
        const { upperFont } = this.state;

        const defaultUpperFont = upperMaxFontSize || height / 1.4;
        const upperFontSize = (upperAutoFit && upperFont) ? upperFont : defaultUpperFont;
        const lowerFontSize = height / 4;

        const upperTextStyle = upperAutoFit
            ? {
                width: '100%',
                fontSize: upperFontSize,
                lineHeight: `${upperFontSize * 1.05}px`,
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
            }
            : {
                fontSize: upperFontSize,
                lineHeight: `${upperFontSize}px`,
            };

        return <div style={{ height, width: height * 2.3 }} className='numberText'>
            <div className='numberText_upper'>
                <div ref={this.upperRef} className='numberText_upper_text' style={upperTextStyle}>
                    {count}
                </div>
            </div>
            <div className='numberText_lower'>
                <div className='numberText_lower_text' style={{ fontSize: lowerFontSize, lineHeight: `${lowerFontSize}px` }}>
                    {text}
                </div>
            </div>
        </div>
    }
}
